// Centralized exports for all utilities
export * from './validation.js';
export * from './api.js';
export * from './responsive.js';
export * from './clipboard.js';
export * from './hooks.js';

// Specific re-exports for convenience
export { handleReferralCode, clearReferralCode, getUrlReferralCode, clearReferralFromUrl, resolveLandingView } from './api.js';

// Additional utility functions
export const formatNumber = (num) => {
  return num ? num.toLocaleString() : 0;
};

export const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export const generateId = () => {
  return Math.random().toString(36).substring(2) + Date.now().toString(36);
};

// User session management
export const userSession = {
  // Save complete user data to localStorage
  save: (userData) => {
    const sessionData = {
      ...userData,
      lastUpdated: Date.now(),
      version: '1.0'
    };
    return storage.set('ffs_user_session', sessionData);
  },
  
  // Get user session data
  get: () => {
    const session = storage.get('ffs_user_session');
    if (!session) return null;
    
    // Check if session is older than 7 days
    const maxAge = 7 * 24 * 60 * 60 * 1000; // 7 days in milliseconds
    if (Date.now() - session.lastUpdated > maxAge) {
      userSession.clear();
      return null;
    }
    
    return session;
  },
  
  // Update specific user data
  update: (updates) => {
    const current = userSession.get();
    if (!current) return false;
    
    const updated = { ...current, ...updates, lastUpdated: Date.now() };
    return storage.set('ffs_user_session', updated);
  },
  
  // Clear user session
  clear: () => {
    return storage.remove('ffs_user_session');
  },
  
  // Check if user has an active session
  isActive: () => {
    return userSession.get() !== null;
  }
};

// Local storage helpers
export const storage = {
  get: (key, defaultValue = null) => {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : defaultValue;
    } catch {
      return defaultValue;
    }
  },
  
  set: (key, value) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch {
      return false;
    }
  },
  
  remove: (key) => {
    try {
      localStorage.removeItem(key);
      return true;
    } catch {
      return false;
    }
  },
};